/* PEVELL v2 UI */
(function () {
  if (window.pvUiInit) return;
  window.pvUiInit = true;

  var bar = null;
  var pending = 0;
  var hideTimer = null;
  var nativeFetch = window.fetch;
  var activeAddButtons = [];
  var buttonTimers = new WeakMap();
  var cartRefreshPromise = null;

  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'pv-loadbar';
    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');
    document.body.appendChild(bar);
    return bar;
  }

  function startLoading() {
    pending++;
    clearTimeout(hideTimer);
    ensureBar().classList.add('is-active');
  }

  function stopLoading() {
    pending = Math.max(0, pending - 1);
    if (pending) return;
    hideTimer = setTimeout(function () {
      if (bar && !pending) bar.classList.remove('is-active');
    }, 180);
  }

  function installButtonLoaderStyles() {
    if (document.getElementById('pv-button-loader-styles')) return;
    var style = document.createElement('style');
    style.id = 'pv-button-loader-styles';
    style.textContent = '\n      .pv-button-loading { position:relative !important; pointer-events:none !important; }\n      .pv-button-loading > * { visibility:hidden !important; }\n      .pv-button-loading > .pv-button-spinner { visibility:visible !important; }\n      .pv-button-loading.pv-card__add::after { content:none !important; }\n      .pv-button-spinner { position:absolute !important; left:50% !important; top:50% !important; width:1.6rem !important; height:1.6rem !important; margin:-0.8rem 0 0 -0.8rem !important; border:2px solid var(--pv-loader-color, currentColor) !important; border-top-color:transparent !important; border-radius:50% !important; animation:pvButtonSpin .65s linear infinite !important; visibility:visible !important; pointer-events:none !important; box-sizing:border-box !important; }\n      @keyframes pvButtonSpin { to { transform:rotate(360deg); } }\n    ';
    document.head.appendChild(style);
  }

  function isCartAddForm(form) {
    if (!form) return false;
    var action = form.getAttribute('action') || '';
    return /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(action) || !!form.querySelector('[name="add"], .product-form__submit, .pv-card__add');
  }

  function isAddButton(button) {
    if (!button || button.disabled) return false;
    if (button.matches('.pv-card__add, [name="add"], .product-form__submit, [data-add-to-cart], [data-pv-add-to-cart]')) return true;
    var form = button.form;
    return !!(form && isCartAddForm(form) && (button.type === 'submit' || button.closest('product-form')));
  }

  function setButtonLoading(button) {
    if (!button || button.dataset.pvButtonLoading === 'true') return;
    installButtonLoaderStyles();
    button.dataset.pvButtonLoading = 'true';
    button.setAttribute('aria-busy', 'true');
    button.style.setProperty('--pv-loader-color', getComputedStyle(button).color);
    button.classList.add('pv-button-loading');
    var spinner = document.createElement('span');
    spinner.className = 'pv-button-spinner';
    spinner.setAttribute('aria-hidden', 'true');
    button.appendChild(spinner);
    setTimeout(function () {
      if (button.dataset.pvButtonLoading !== 'true') return;
      button.setAttribute('aria-disabled', 'true');
      if (button.tagName === 'BUTTON') button.disabled = true;
    }, 0);
    activeAddButtons.push(button);
    buttonTimers.set(button, setTimeout(function () { clearButtonLoading(button); }, 12000));
  }

  function clearButtonLoading(button) {
    if (!button || button.dataset.pvButtonLoading !== 'true') return;
    var timer = buttonTimers.get(button);
    if (timer) clearTimeout(timer);
    buttonTimers.delete(button);
    var spinner = button.querySelector('.pv-button-spinner');
    if (spinner) spinner.remove();
    button.dataset.pvButtonLoading = 'false';
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
    button.classList.remove('pv-button-loading');
    button.style.removeProperty('--pv-loader-color');
    if (button.tagName === 'BUTTON') button.disabled = false;
    activeAddButtons = activeAddButtons.filter(function (item) { return item !== button; });
  }

  function clearAllAddButtonLoading() {
    activeAddButtons.slice().forEach(clearButtonLoading);
  }

  function waitForCartDrawerOpen(drawer) {
    if (!drawer) return Promise.resolve();
    return new Promise(function (resolve) {
      var settled = false;
      var timer = setTimeout(finish, 700);
      function finish() {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        drawer.removeEventListener('transitionend', onTransitionEnd);
        resolve();
      }
      function onTransitionEnd(event) {
        if (event.target === drawer) finish();
      }
      drawer.addEventListener('transitionend', onTransitionEnd);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (drawer.hasAttribute('open') || drawer.classList.contains('active') || drawer.classList.contains('is-open')) finish();
        });
      });
    });
  }

  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.renderContents !== 'function') return Promise.resolve();
    if (cartRefreshPromise) return cartRefreshPromise;

    var ids = drawer.getSectionsToRender().map(function (section) { return section.id; }).filter(Boolean);
    if (!ids.length || typeof nativeFetch !== 'function') return Promise.resolve();

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    var sectionUrl = window.location.pathname + '?sections=' + encodeURIComponent(ids.join(','));

    cartRefreshPromise = Promise.all([
      nativeFetch(sectionUrl, { headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('Cart sections request failed');
        return response.json();
      }),
      nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('Cart state request failed');
        return response.json();
      })
    ]).then(function (results) {
      var sections = results[0] || {};
      var cart = results[1] || {};
      var rendered = {};
      ids.forEach(function (id) { if (sections[id]) rendered[id] = sections[id]; });
      if (Object.keys(rendered).length) {
        var lastItem = cart.items && cart.items.length ? cart.items[cart.items.length - 1] : {};
        drawer.renderContents(Object.assign({}, lastItem, { item_count: cart.item_count, sections: rendered }));
      }
      if (cart.item_count > 0) drawer.classList.remove('is-empty');
      return waitForCartDrawerOpen(drawer);
    }).catch(function (error) {
      console.error('Pevell cart drawer refresh:', error);
    }).finally(function () {
      cartRefreshPromise = null;
    });
    return cartRefreshPromise;
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var url = '';
      try { url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || ''; } catch (e) {}
      var isCartAdd = /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url);
      startLoading();
      var request;
      try { request = nativeFetch.apply(this, args); } catch (error) {
        stopLoading();
        if (isCartAdd) clearAllAddButtonLoading();
        throw error;
      }
      if (!request || typeof request.then !== 'function') { stopLoading(); return request; }
      return request.then(async function (response) {
        if (isCartAdd && response && response.ok) {
          // The add-to-cart handler renders Shopify's bundled cart sections.
          // Do not run a second section refresh here: it can overwrite the
          // correct post-add drawer markup with a stale/empty section response.
          clearAllAddButtonLoading();
        } else if (isCartAdd) {
          clearAllAddButtonLoading();
        }
        stopLoading();
        return response;
      }, function (error) {
        if (isCartAdd) clearAllAddButtonLoading();
        stopLoading();
        throw error;
      });
    };
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button, input[type="submit"], [role="button"]');
    if (button && isAddButton(button)) setButtonLoading(button);

    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || (link.target && link.target !== '_self') || link.hasAttribute('download')) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
    if (link.origin && link.origin !== window.location.origin) return;
    if (link.href !== window.location.href) startLoading();
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (isCartAddForm(form)) {
      var submitter = event.submitter || form.querySelector('[name="add"], .product-form__submit, .pv-card__add, [type="submit"]');
      if (submitter) setButtonLoading(submitter);
    }
    startLoading();
  }, true);

  window.addEventListener('pageshow', function () {
    pending = 0;
    if (bar) bar.classList.remove('is-active');
    clearAllAddButtonLoading();
  });

  function makeDraggable(track) {
    if (track.pvDragBound) return;
    track.pvDragBound = true;
    var down = false, moved = false, startX = 0, startScroll = 0, pointerId = null;
    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      down = true; moved = false; startX = event.clientX; startScroll = track.scrollLeft; pointerId = event.pointerId;
      track.setPointerCapture(pointerId);
    });
    track.addEventListener('pointermove', function (event) {
      if (!down) return;
      var dx = event.clientX - startX;
      if (!moved && Math.abs(dx) > 4) { moved = true; track.classList.add('is-dragging'); }
      if (moved) { event.preventDefault(); track.scrollLeft = startScroll - dx; }
    });
    function release() {
      if (!down) return;
      down = false;
      if (pointerId !== null && track.hasPointerCapture && track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
      pointerId = null;
      if (moved) setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
    }
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('pointerleave', release);
    track.addEventListener('click', function (event) {
      if (track.classList.contains('is-dragging')) { event.preventDefault(); event.stopPropagation(); }
    }, true);
    track.addEventListener('dragstart', function (event) { event.preventDefault(); });
    var wrap = track.closest('.pv-rail, .pv-media, .pv-cats-wrap') || track.parentElement;
    if (wrap) wrap.querySelectorAll('.pv-rail__btn').forEach(function (button) {
      button.addEventListener('click', function () {
        var dir = button.dataset.dir === 'prev' ? -1 : 1;
        var first = track.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
    });
  }

  function initRails(root) {
    (root || document).querySelectorAll('.pv-rail__track, .pv-cats, .pv-chips').forEach(makeDraggable);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initRails(); });
  else initRails();
  document.addEventListener('shopify:section:load', function (event) { initRails(event.target); });
})();

/* ---------- Color filter LIFO + responsive swatch capacity ---------- */
(function () {
  if (window.__pvColorLifoFix) return;
  window.__pvColorLifoFix = true;

  var cardState = new WeakMap();
  var applyTimer = null;
  var resizeTimer = null;
  var lastFilterSignature = null;

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function selectedColorsFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var values = [];
    params.getAll('pv_color').forEach(function (value) {
      String(value || '').split(/\|+|,+/).forEach(function (part) {
        var key = normalize(part);
        if (key && values.indexOf(key) === -1) values.push(key);
      });
    });
    return values;
  }

  function filterSignature(colors) {
    return colors.join('|');
  }

  function mobileLimit() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 3 : 6;
  }

  function getColor(button) {
    return normalize(button.getAttribute('aria-label') || button.getAttribute('title') || '');
  }

  function stateFor(card) {
    var state = cardState.get(card);
    var buttons = Array.prototype.slice.call(card.querySelectorAll('.pv-gc__sw'));
    if (!state || state.nodes.length !== buttons.length || state.nodes.some(function (node, index) { return node !== buttons[index] && state.nodes.indexOf(buttons[index]) === -1; })) {
      state = { nodes: buttons.slice(), clickedColor: '' };
      cardState.set(card, state);
    } else {
      state.nodes = buttons.slice();
    }
    return state;
  }

  function clearClickOverrides() {
    document.querySelectorAll('.pv-gc[data-pv-grid-card]').forEach(function (card) {
      var state = cardState.get(card);
      if (state) state.clickedColor = '';
    });
  }

  function applyCard(card, selectedColors) {
    var wrap = card.querySelector('.pv-gc__swatches');
    if (!wrap) return;

    var state = stateFor(card);
    var nodes = state.nodes.filter(function (node) { return node && node.isConnected && wrap.contains(node); });
    if (!nodes.length) return;

    var limit = mobileLimit();
    var byColor = Object.create(null);
    nodes.forEach(function (node) {
      var color = getColor(node);
      if (color && !byColor[color]) byColor[color] = node;
    });

    var selectedForCard = selectedColors.filter(function (color) { return !!byColor[color]; });
    var desired = nodes.slice(0, Math.min(limit, nodes.length));

    selectedForCard.forEach(function (color) {
      var node = byColor[color];
      if (!node || desired.indexOf(node) !== -1) return;
      var selectedSet = Object.create(null);
      selectedForCard.forEach(function (selected) { selectedSet[selected] = true; });
      var removeIndex = -1;
      for (var i = desired.length - 1; i >= 0; i--) {
        if (!selectedSet[getColor(desired[i])]) {
          removeIndex = i;
          break;
        }
      }
      if (removeIndex < 0) removeIndex = desired.length - 1;
      if (removeIndex >= 0) desired.splice(removeIndex, 1);
      desired.unshift(node);
    });

    var desiredSet = new Set(desired);
    var currentButtons = Array.prototype.slice.call(wrap.querySelectorAll('.pv-gc__sw'));
    var targetOrder = desired.concat(nodes.filter(function (node) { return !desiredSet.has(node); }));
    var orderChanged = currentButtons.length !== targetOrder.length || currentButtons.some(function (node, index) { return node !== targetOrder[index]; });
    if (orderChanged) targetOrder.forEach(function (node) { wrap.appendChild(node); });

    desired.forEach(function (node) {
      node.classList.remove('pv-gc__sw--extra');
      node.hidden = false;
    });
    nodes.forEach(function (node) {
      if (desiredSet.has(node)) return;
      node.classList.add('pv-gc__sw--extra');
      node.hidden = true;
    });

    var more = wrap.querySelector('[data-pv-sw-more]');
    if (more) {
      var hiddenCount = Math.max(0, nodes.length - desired.length);
      more.hidden = hiddenCount === 0;
      if (hiddenCount > 0) {
        more.textContent = '+' + hiddenCount;
        more.setAttribute('data-pv-sw-total', String(nodes.length));
      }
      if (wrap.lastElementChild !== more) wrap.appendChild(more);
    }

    var activeColor = '';
    if (state.clickedColor && byColor[state.clickedColor]) {
      activeColor = state.clickedColor;
    } else if (selectedForCard.length) {
      activeColor = selectedForCard[selectedForCard.length - 1];
    }

    if (activeColor) {
      nodes.forEach(function (node) {
        node.classList.toggle('is-active', getColor(node) === activeColor);
      });
    }
  }

  function applyAll() {
    applyTimer = null;
    var selectedColors = selectedColorsFromUrl();
    var signature = filterSignature(selectedColors);
    if (lastFilterSignature !== null && signature !== lastFilterSignature) clearClickOverrides();
    lastFilterSignature = signature;
    document.querySelectorAll('.pv-gc[data-pv-grid-card]').forEach(function (card) {
      applyCard(card, selectedColors);
    });
  }

  function scheduleApply() {
    if (applyTimer) return;
    applyTimer = setTimeout(applyAll, 40);
  }

  function scheduleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(scheduleApply, 80);
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('.pv-gc__sw');
    if (!swatch) return;
    var card = swatch.closest('.pv-gc[data-pv-grid-card]');
    if (!card) return;
    var state = stateFor(card);
    var color = getColor(swatch);
    if (!color) return;
    state.clickedColor = color;
    state.clickedAt = Date.now();
    state.nodes = Array.prototype.slice.call(card.querySelectorAll('.pv-gc__sw'));
    state.nodes.forEach(function (node) {
      node.classList.toggle('is-active', node === swatch);
    });
    setTimeout(function () {
      if (!card.isConnected) return;
      var currentState = cardState.get(card);
      if (!currentState || currentState.clickedColor !== color) return;
      var currentNode = currentState.nodes.find(function (node) { return getColor(node) === color && node.isConnected; });
      if (currentNode) {
        currentState.nodes.forEach(function (node) { node.classList.toggle('is-active', node === currentNode); });
      }
    }, 0);
  }, true);

  var observer = new MutationObserver(function () { scheduleApply(); });
  function startObserver() {
    if (!document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
    applyAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }

  ['pushState', 'replaceState'].forEach(function (method) {
    var original = history[method];
    if (typeof original !== 'function') return;
    history[method] = function () {
      var result = original.apply(this, arguments);
      window.dispatchEvent(new Event('pv:urlchange'));
      return result;
    };
  });

  window.addEventListener('pv:urlchange', scheduleApply);
  window.addEventListener('popstate', scheduleApply);
  window.addEventListener('resize', scheduleResize, { passive: true });
  document.addEventListener('shopify:section:load', scheduleApply);
})();
